export default "__VITE_ASSET__9942ab6a__"